import React from 'react'
import { StepType, TourProvider } from '../Other/tour';
import { DI, DIProps } from '../../Core';
import { Box, Text, BlockStack } from '@shopify/polaris';

interface Props extends DIProps {
    children: any
}

const TourComponent = (props: Props) => {

    
    return (
        <TourProvider steps={[]} disableInteraction onClickClose={() => {
        }} OnNext={(data) => {
        }} OnBack={(data) => {
        }}>
            {props.children}
        </TourProvider>
    )
}

export default DI(TourComponent)